import React, { ReactNode } from "react";

import { useObject } from "@hooks/useObject";
import { TagSearchSortTypes } from "@features/library/types";

import { initialState, TagLibraryContext } from "./TagLibraryContext";
import { buildTagSearchInputFromQuery } from "@features/library/utils";

interface Props {
  children: ReactNode;
}

export default function TagLibraryProvider({ children }: Props) {
  const [sort, setSortBy] = React.useState<TagSearchSortTypes>(initialState.sort);
  const [query, setQuery] = React.useState<string>(initialState.query);

  const filters = React.useMemo(
    () => (query ? [buildTagSearchInputFromQuery(query)] : []),
    [query]
  );

  const context = useObject({ query, setQuery, sort, setSortBy, filters });

  return <TagLibraryContext.Provider value={context}>{children}</TagLibraryContext.Provider>;
}

export const useTagLibraryContext = () => React.useContext(TagLibraryContext);
